// extracted by mini-css-extract-plugin
export default {"areaButton":"DropDownADD_areaButton__ygg2U"};